import { Box, IconButton, Tooltip } from '@chakra-ui/react'
import { CameraOn, CameraOff } from 'src/components/icon'

import { useLocalPlayer } from '../../context/localPlayerContext'
import { useVideoCallRoom } from '../../context/videoCallRoomContext'
import {
  ControlButtonType,
  getButtonSize,
  getIconSize,
  getIndicatorProps,
} from '../../utils/controlButtonUtil'
import { ErrorIndicatorIcon } from '../ErrorIndicatorIcon/ErrorIndicatorIcon'

type Props = {
  type?: ControlButtonType
  colorScheme?: 'blue' | 'green'
}
export const CameraButton: React.FC<Props> = ({
  type = 'normal',
  colorScheme,
}) => {
  const { roomStatus } = useVideoCallRoom()
  const { localCameraEnabled, toggleLocalCamera, localCameraError } =
    useLocalPlayer()

  const buttonSize = getButtonSize(type)
  const iconSize = getIconSize(type)
  const indicatorProps = getIndicatorProps(type)

  return (
    <Tooltip
      label={localCameraEnabled ? 'カメラをオフにする' : 'カメラをオンにする'}
    >
      <Box pos="relative">
        <IconButton
          aria-label={
            localCameraEnabled ? 'カメラをオフにする' : 'カメラをオンにする'
          }
          variant="customIconButtonSolid"
          w={buttonSize}
          h={buttonSize}
          colorScheme={localCameraEnabled ? colorScheme : 'red'}
          isDisabled={roomStatus === 'left'}
          icon={
            localCameraEnabled ? (
              <CameraOn size={iconSize} />
            ) : (
              <CameraOff size={iconSize} />
            )
          }
          onClick={toggleLocalCamera}
        />
        {!!localCameraError && <ErrorIndicatorIcon {...indicatorProps} />}
      </Box>
    </Tooltip>
  )
}
